{
	"title": "Adicionar produto ao menu",
	"productInformation": "Informações do produto",
	"product": "Produto",
	"price": "Preço de venda",
	"add": "Adicionar produto",
	"validateField": "Campo obrigatório"
}
